import type { JSONContent } from "@tiptap/core";
import type { Editor } from "@tiptap/react";

/**
 * Update the old editor before `setBaseline`: it synchronously wakes `useDiff`, which reads the old editor's doc.
 * Go through the options owner's `setBaseline`, not a command, or the next options update restores the old baseline.
 */
const resetDiffBaseline = (
	newEditor: Editor | null,
	oldEditor: Editor | null,
	setBaseline: (baseline: JSONContent) => void,
) => {
	if (!newEditor || newEditor.isDestroyed) return;
	if (oldEditor && !oldEditor.isDestroyed) {
		oldEditor.commands.setContent(newEditor.getJSON(), { emitUpdate: false });
	}
	setBaseline(newEditor.state.doc.content.toJSON());
};

export default resetDiffBaseline;
